<template>
  <div class="header-container">
    <div class="logo-container">
        <img @click="onClickButton()" class="logo" src="~@/assets/imgs/logo.svg" />
    </div>
    <div v-if="currentPage == 2" class="text-container">
      <h2>VOILÀ LE RÉSULTAT!</h2>
      <p>Voici ton design.<br />
          Il te plaît? Ou souhaites-tu le modifier?<br />
          Clique simplement sur le bouton correspondant</p>
    </div>
    <div v-else-if="currentPage == 3 || currentPage == 4" class="text-container">
      <h2>Très bien, alors à tout de suite!</h2>
          <p>Presque terminé.
            Dis-nous simplement pour qui est le briquet et tu pourras venir à notre stand récupérer ta pièce design!</p>
    </div>
    <div v-else class="text-container">
      <h2>ÉBAUCHE TON DESIGN</h2>
      <p>C’est parti: sélectionne les icônes et le texte que tu souhaites utiliser pour ton design.
        Ensuite, tu peux redimensionner et définir la position sur ton briquet. Lâche-toi!</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Head",
  props: ['currentPage'],
  methods: {
    onClickButton () {
      this.$emit('start')
    }
  }
}
</script>
<style lang="scss" scoped>
.header-container {
  display: flex;
  min-height: 185px;

  .logo-container {
    padding-right: 42px;
    padding-bottom: 0px;
    margin-top: 32px;
    border-right: 2px solid #0032A0;
    img {
      cursor: pointer;
    }
  }
  .text-container {
    padding-top: 32px;
    padding-left: 47px;
    p {
      max-width: 390px;
      font-size: 19px;
      font-weight: bold;
      line-height: 23px;
      color: black;
    }
    h2 {
      font-weight: bold;
      font-size: 30px;
      line-height: 37px;
      text-transform: uppercase;
    }
  }
}

</style>
